import { BaseBrush } from './BaseBrush';
import { Grid } from '../Grid';

export class Cooler extends BaseBrush {
    name = 'cooler';
    
    protected applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void {
        const particle = grid.get(x, y);
        if (particle && !particle.empty) {
            // 越靠近中心，冷却效果越强
            const factor = maxDist > 0 ? (1 - dist / maxDist) : 1;
            // 冷却速度
            // 降低冷却速度，使其更像 Heater 的渐变过程，避免水瞬间结冰
            // Heater 是 0.5 + 2.0 * factor，但水的温差范围小 (20->0)，所以这里调小一点
            const coolAmount = 0.1 + 0.5 * factor;
            
            particle.temperature -= coolAmount;
            
            // 限制最低温
            if (particle.minTemp !== undefined) {
                particle.temperature = Math.max(particle.minTemp, particle.temperature);
            }
        }
    }
}
